export default __webpack_public_path__ + "static/media/pos-pro-22.c88083e8.jpg";